// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! muse-css:product:R_LYX- */\n.rLooM{align-items:center;background-color:var(--audio-overlay-on-image-default);border-radius:var(--audio-radius-pill);color:var(--audio-exception-light);display:flex;flex-shrink:0;height:4.25rem;justify-content:center;transition:background-color .2s ease;width:4.25rem}.rLooM:hover{background-color:var(--audio-overlay-on-image-hovered,var(--audio-overlay-on-image-default))}._6NrCz{height:1.75rem;width:1.75rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": "rLooM",
	"icon": "_6NrCz"
};
export default ___CSS_LOADER_EXPORT___;
